<template>
  <footer class="footer">
    <div class="container-fluid">
      <ul class="nav">
        <li class="nav-item">
          <a class="nav-link" href="https://www.rfc-editor.org/info/rfc7999">
           RFC-7999 
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://www.ripe.net/analyse/internet-measurements/routing-information-service-ris/"> Ripe RIS </a>
        </li>
      </ul>
      <div class="copyright">
        © {{ year }} made with <i class="tim-icons icon-heart-2"></i> by
        <a href="https://github.com/brennoo" target="_blank" rel="noopener">Brenno Oliveira</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
